import React, {FunctionComponent} from "react";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";

export const DocumentDragDropContext: FunctionComponent = ({children}) => (
  <DndProvider backend={HTML5Backend}>{children}</DndProvider>
);
